import clsx from 'clsx';
import { useCallback, useState } from 'react';
import { NavLink } from 'react-router-dom';

import useFullscreen from 'hooks/useFullscreen';
import { AppHeader as NetlineAppHeader, styled } from 'netline-ui';
import { getMainConfig, isUrl } from 'utils';

import EnvironmentIndicator from '../EnvironmentIndicator/EnvironmentIndicator';

import styles, { appHeaderClasses, appHeaderMainClassess } from './AppHeader.styles';
import AppHeaderRight from './AppHeaderRight/AppHeaderRight';
import AppHeaderTitle from './AppHeaderTitle/AppHeaderTitle';
import ProductsMenu from './ProductsMenu/ProductsMenu';
import useProducts from './useProducts';

const AppHeaderRoot = styled('div', { name: appHeaderClasses.$name })(styles);

const AppHeader = () => {
  const [productsMenuAnchorEl, setProductsMenuAnchorEl] = useState(null);
  const products = useProducts();
  const productsVisible = products.size > 0;
  const isFullscreenEnabled = useFullscreen();

  const handleMenuClick = useCallback((event) => {
    setProductsMenuAnchorEl(event.currentTarget);
  }, []);

  const handleProductMenuClose = useCallback(() => {
    setProductsMenuAnchorEl(null);
  }, []);

  const logoUrl = getMainConfig('logoUrl') || undefined;

  return (
    <AppHeaderRoot className={appHeaderClasses.root}>
      <EnvironmentIndicator />
      <NetlineAppHeader
        title={<AppHeaderTitle />}
        onMenuClick={productsVisible ? handleMenuClick : undefined}
        LinkComponent={NavLink}
        ImgProps={{
          src: isUrl(logoUrl) ? logoUrl : `logo/${logoUrl || 'default-logo.svg'}`,
          alt: 'logo',
        }}
        size="large"
        className={clsx(appHeaderClasses.main, {
          [appHeaderMainClassess.hidden]: isFullscreenEnabled,
        })}
        data-testid="AppHeader-main"
      >
        <AppHeaderRight />
        {productsVisible && (
          <ProductsMenu
            className={appHeaderClasses.productsMenu}
            open={!!productsMenuAnchorEl}
            anchorEl={productsMenuAnchorEl}
            products={products}
            onClose={handleProductMenuClose}
          />
        )}
      </NetlineAppHeader>
    </AppHeaderRoot>
  );
};

export default AppHeader;
